import apiClient from './api/client';
import { ENDPOINTS } from './api/endpoints';

const settlementReportService = {
  list: (sellerAccountId) =>
    apiClient.get(ENDPOINTS.SETTLEMENT_REPORTS.LIST, { params: { sellerAccountId } }),

  sync: (sellerAccountId) =>
    apiClient.post(ENDPOINTS.SETTLEMENT_REPORTS.SYNC, null, { params: { sellerAccountId } }),

  getById: (id) => apiClient.get(ENDPOINTS.SETTLEMENT_REPORTS.GET_BY_ID(id)),

  parse: (id) => apiClient.post(ENDPOINTS.SETTLEMENT_REPORTS.PARSE(id)),

  getTransactions: (id, type) =>
    apiClient.get(ENDPOINTS.SETTLEMENT_REPORTS.TRANSACTIONS(id), {
      params: type ? { type } : undefined,
    }),

  // Returns the raw TSV as a string — use for download.
  getRawTsv: (id) =>
    apiClient.get(ENDPOINTS.SETTLEMENT_REPORTS.GET_RAW(id), { responseType: 'text' }),

  // Per-report aggregations (legacy drill-in)
  getOverview: (id) => apiClient.get(ENDPOINTS.SETTLEMENT_REPORTS.OVERVIEW(id)),
  getOrderPnl: (id) => apiClient.get(ENDPOINTS.SETTLEMENT_REPORTS.ORDER_PNL(id)),

  // Range-based aggregations (preferred)
  getOverviewByRange: (sellerAccountId, from, to) =>
    apiClient.get(ENDPOINTS.SETTLEMENT_REPORTS.RANGE_OVERVIEW, {
      params: { sellerAccountId, from, to },
    }),
  getOrderPnlByRange: (sellerAccountId, from, to) =>
    apiClient.get(ENDPOINTS.SETTLEMENT_REPORTS.RANGE_ORDER_PNL, {
      params: { sellerAccountId, from, to },
    }),
  getTransactionsByRange: (sellerAccountId, from, to, type) =>
    apiClient.get(ENDPOINTS.SETTLEMENT_REPORTS.RANGE_TRANSACTIONS, {
      params: { sellerAccountId, from, to, ...(type ? { type } : {}) },
    }),
  getBucketTransactions: (sellerAccountId, from, to, bucket) =>
    apiClient.get(ENDPOINTS.SETTLEMENT_REPORTS.RANGE_BUCKET_TXS, {
      params: { sellerAccountId, from, to, bucket },
    }),
  getSkuPerformance: (sellerAccountId, from, to) =>
    apiClient.get(ENDPOINTS.SETTLEMENT_REPORTS.RANGE_SKU_PERF, {
      params: { sellerAccountId, from, to },
    }),
  getSettlementsInRange: (sellerAccountId, from, to) =>
    apiClient.get(ENDPOINTS.SETTLEMENT_REPORTS.RANGE_SETTLEMENTS, {
      params: { sellerAccountId, from, to },
    }),

  // Three-question cashflow: net for period, bank credits in window, current Reserve.
  // refreshReserve=true forces an SP-API call (bypasses 6h DB cache).
  getCashflow: (sellerAccountId, from, to, refreshReserve = false) =>
    apiClient.get(ENDPOINTS.SETTLEMENT_REPORTS.RANGE_CASHFLOW, {
      params: { sellerAccountId, from, to, refreshReserve },
    }),
};

export default settlementReportService;
